import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Typography from '@material-ui/core/Typography';
import { green, white } from '../../Constants/Colors';
import InfoIcon from '../../Resources/Images/icon-info-2.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: white,
    marginBottom: '60px',
    height: '140px',
    [theme.breakpoints.down('sm')]: {
      height: '180px',
    },
  },
  iconContainer: {
    position: 'relative',
    minWidth: '50px',
    width: '50px',
    height: '100%',
    backgroundColor: green,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: '70%',
    filter: 'brightness(0) invert(1)',
  },
  textContainer: {
    padding: '30px',
  },
  heading: {
    fontWeight: 'bold',
  },
}));

interface ComponentHintProps {
  hintText: string;
}

const ComponentHint = ({ hintText }: ComponentHintProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <img className={classes.icon} src={InfoIcon} />
      </div>
      <div className={classes.textContainer}>
        <Typography variant="body1" className={classes.heading}>
          {t('componentHintHeader')}
        </Typography>
        <Typography variant="body1">{hintText}</Typography>
      </div>
    </div>
  );
};

export default ComponentHint;
